import React, { useState } from "react";
import { Badge, Img, Spinner } from "../../../../../../../../Components";
import { FiInfo } from "react-icons/fi";
import Layovers from "../../../Oneway/Result/Components/layovers";
import { minutesToHrMin, parseTerminalName, StampTo24hr } from "../../../../../../../../Utils/utils";
import { FaPlane } from "react-icons/fa";
import moment from "moment";
import { MdLuggage, MdShoppingBag } from "react-icons/md";

function FlightCard({ segments, duration, baggage, journeyLabel }) {
	const departure = segments[0];
	const arrival = segments[segments.length - 1];
	const [ShowLayovers, setShowLayovers] = useState();

	const { departureTerminal, logo, departureTime, airlineName, airlineCode, flightNumber, departureCode, departureAirport } = departure || {};
	const { arrivalTime, arrivalCode, arrivalTerminal, arrivalAirport } = arrival || {};

	if (segments.length)
		return (
			<div className="mt-3 overflow-hidden border rounded-lg fade-in-up">
				<div className="p-3 border-b sm:p-4 flex-center-between bg-light">
					<div className="min-w-0">
						<h4 className="mr-2">{moment.utc(departureTime).format("DD MMM YYYY")}</h4>
						<h4 className="text-secondary text-sm">
							{departureCode} - {arrivalCode}
						</h4>
					</div>
					{journeyLabel && (
						<Badge variant="light" className="text-[11px] shrink-0">
							{journeyLabel}
						</Badge>
					)}
					{baggage && (
						<div className="hidden gap-2 text-xs md:align-center md:flex">
							<Badge>
								<MdShoppingBag className="mr-1" /> Cabin {baggage[`${departureCode}-${arrivalCode}`]?.[0]?.cabin}
							</Badge>
							<Badge>
								<MdLuggage className="mr-1" /> CheckIn {baggage[`${departureCode}-${arrivalCode}`]?.[0]?.checkIn}
							</Badge>
						</div>
					)}
				</div>
				<div className="col-span-2">
					<div className="p-3 pb-2 sm:p-4 flex items-center gap-3 border-b border-surface/50">
						<Img src={logo} alt={airlineCode} className="w-10 h-10 rounded-full !bg-canvas shrink-0" />
						<div className="text-xs text-secondary min-w-0">
							<span className="font-medium text-dark">{airlineName}</span>
							<span className="ml-1">{airlineCode}-{flightNumber}</span>
						</div>
					</div>
					<div className="p-3 sm:p-4 grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-start gap-2 sm:gap-4 min-w-0">
						<div className="min-w-0">
							<div className="text-3xl font-bold leading-none whitespace-nowrap">{StampTo24hr(departureTime)}</div>
							<div className="text-sm text-secondary">{departureCode}</div>
							<div className="text-xs leading-4 text-secondary break-words">{departureAirport}</div>
							{departureTerminal && <div className="text-xs leading-4 text-secondary break-words">{parseTerminalName(departureTerminal)}</div>}
						</div>
						<div className="w-[5.25rem] sm:w-[6.5rem]">
							<div className="mb-2 text-xs text-center text-secondary whitespace-nowrap">{minutesToHrMin(duration)}</div>
							<div className="align-center">
								<div className="w-2 h-2 border rounded-full border-dark shrink-0" />
								<div className="flex-grow border-t border-dashed border-muted min-w-0" />
								<FaPlane className="shrink-0" />
								<div className="flex-grow border-t border-dashed border-muted min-w-0" />
								<div className="w-2 h-2 border rounded-full border-dark shrink-0" />
							</div>
							<div className="mt-2 text-xs text-center text-secondary whitespace-nowrap">
								{segments.length === 1
									? "Non-Stop"
									: `${segments.length - 1} stop (via ${segments
											.slice(1)
											?.map((segment) => `${segment.departureCode}`)
											.join(", ")})`}
							</div>
						</div>
						<div className="min-w-0">
							<div className="text-3xl font-bold leading-none whitespace-nowrap">{StampTo24hr(arrivalTime)}</div>
							<div className="text-sm text-secondary">{arrivalCode}</div>
							<div className="text-xs leading-4 text-secondary break-words">{arrivalAirport}</div>
							{arrivalTerminal && <div className="text-xs leading-4 text-secondary break-words">{parseTerminalName(arrivalTerminal)}</div>}
						</div>
					</div>
					{segments.length > 1 && (
						<div onClick={() => setShowLayovers(segments)} className="gap-2 p-2 border-t rounded-bl cursor-pointer flex-center bg-light hover:bg-canvas">
							<div className="gap-1 text-xs text-secondary flex-center">
								<FiInfo />
								Layovers
							</div>
							{segments.map((segment, i) => (
								<>
									<div key={i} className="w-5 h-1 mt-1 border-t border-dotted border-secondary" />
									<Img src={segment.logo} alt={airlineCode} className="w-6 h-6 rounded-full" />
								</>
							))}
						</div>
					)}
				</div>
				<Layovers segments={ShowLayovers} onClose={() => setShowLayovers()} />
			</div>
		);

	return (
		<div className="flex-center">
			<Spinner />
		</div>
	);
}

export default FlightCard;
